const rootEl = document.getElementById('ymmApp');
const ymmApp = Vue.createApp({
    data() {
        return {
            isMounted: false,
            products: {},
            product: null,
            special: false,
            fits: false,
            ymmMatrix: {},
            years: [],
            models: [],
            trims: [],
            edit: null,
            addNew: false,
            open: false,
            specialOpen: false,
            dropdowns: {'year':'','model':'','trim':'','name':''},
            template: {'year':'','model':'','trim':'','name':''},
            errors: {'year':false,'model':false,'trim':false},
            api_url: 'https://tesbros.myshopify.com/api/2022-07/graphql',
            api_headers: new Headers({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Shopify-Storefront-Access-Token': '2573adcacd496b472c79b43f0eaeffc5'
            })
        }
    },
    watch: {
        'dropdowns.year': {
            handler(newValue, oldValue) {
                this.dropdowns.model = '';
                this.dropdowns.trim = '';
            },
            deep: true
        },
        'dropdowns.model': {
            handler(newValue, oldValue) {
                this.dropdowns.trim = '';
            },
            deep: true
        },
    },
    created() {
        window.addEventListener('load.more.success', (event) => {
            this._updateCollection(false,true);
        });
        window.addEventListener('filtered.success', (event) => {
            this._updateCollection(true,false);
        });
        window.addEventListener('open.tesla.popup', (event) => {
            this.openPopup();
        });
        const container = document.querySelector('#ymmProductApp');
        const mobileContainer = document.querySelector('.product__mobile-header');
        const desktopContainer = document.querySelector('.product__information');
        
        if(window.innerWidth < 799) {
            if(desktopContainer && desktopContainer.querySelector('#ymmProductApp')) {
                $(container).prependTo(mobileContainer);
            }
        } else {
            if(mobileContainer && mobileContainer.querySelector('#ymmProductApp')) {
                $(container).prependTo(desktopContainer);
            }
        }
        window.addEventListener('resize', () => {
            if(window.innerWidth < 799) {
                if(desktopContainer && desktopContainer.querySelector('#ymmProductApp')) {
                    $(container).prependTo(mobileContainer);
                }
            } else {
                if(mobileContainer && mobileContainer.querySelector('#ymmProductApp')) {
                    $(container).prependTo(desktopContainer);
                }
            }
        });
        window.addEventListener('orientationchange', () => {
            if(window.innerWidth < 799) {
                if(desktopContainer.querySelector('#ymmProductApp')) {
                    $(container).prependTo(mobileContainer);
                }
            } else {
                if(mobileContainer.querySelector('#ymmProductApp')) {
                    $(container).prependTo(desktopContainer);
                }
            }
        });
    },
    mounted () {
        this._initCustomerToken();
        const section = document.querySelector('[data-ymm-type="ymm-data"]').innerHTML;
        const sectionData = JSON.parse(section);
        this._initModelData(sectionData);
        setTimeout(() => {
            this._updateCollection();
            if(this.product) {
                if(document.getElementById('limitless-special')) {
                    this.special = document.getElementById('limitless-special').innerHTML;
                }
                this._updateProductBlocks();
            }
        },150);
        setTimeout(() => {
            this.isMounted = true;
        },250);
    },
    computed: {
        myCars() {
            return store.getters['garage/cars'];
        },
        activeCar() {
            if(this.myCars.length > 0) {
                let found = this.myCars.find(car => car.active === true);
                if(!found) {
                    found = this.myCars[0];
                    store.dispatch('garage/change', {
                        index: 0
                    })
                }
                return found;
            }
        },
        activeCarLabel() {
            if(this.activeCar) {
                return (this.activeCar.name && this.activeCar.name !== '') ? this.activeCar.name : this.activeCar.year + ' ' + this.activeCar.model;
            }
        },
        yearModels() {
            if(this.dropdowns.year !== '') {
                return Object.keys(this.ymmMatrix[this.dropdowns.year]);
            } else {
                return [];
            }
        },
        modelTrims() {
            if(this.dropdowns.year !== '' && this.dropdowns.model !== '') {
                return Object.values(this.ymmMatrix[this.dropdowns.year][this.dropdowns.model])
            } else {
                return [];
            }
        }
    },
    methods: {
        _updateProductBlocks() {
            this.fits = false;
            if(this.myCars.length > 0) {
                if(!this.products.hasOwnProperty(this.product)) {
                    return;
                }
                if(this.product && this.products && this.products.hasOwnProperty(this.product)) {
                    let models = this.products[this.product];
                    models.forEach(model => {
                        if(model.year === this.activeCar['year'] && model.model === this.activeCar['model'] && model.trim === this.activeCar['trim']) {
                            this.fits = true;
                        }
                    })
                }
            }
        },
        _updateCollection(reset,skipSort) {
            reset = (typeof reset === 'undefined') ? false : reset;
            skipSort = (typeof skipSort === 'undefined') ? false : skipSort;
            let productCards = [];
            if(reset) {
                productCards = document.querySelectorAll('[data-product-fits]');
            } else {
                productCards = document.querySelectorAll('[data-product-fits=""]');
            }

            if(productCards.length > 0) {
                if(this.myCars.length > 0) {
                    const collectionMatrix = document.querySelector('.collection-matrix');
                    const sortBy = (collectionMatrix && collectionMatrix.dataset.sortBy) ? collectionMatrix.dataset.sortBy : '';
                    let sorted = {
                        'yes': [],
                        'maybe': [],
                        'no': []
                    };
                    productCards.forEach((productCard) => {
                        let productYMM = [];
                        let fits = "";
                        const productId = productCard.dataset.productId;
                        const productY = productCard.dataset.productYear ? productCard.dataset.productYear.split('|') : [];
                        const productM = productCard.dataset.productModel ? productCard.dataset.productModel.split('|') : [];
                        const productT = productCard.dataset.productTrim ? productCard.dataset.productTrim.split('|') : [];
                        const productSpecialFit = productCard.dataset.productSpecialFit ? true : false;
                        if(productY.length > 0 && productM.length > 0 && productT.length > 0) {
                            productY.forEach((year) => {
                                productM.forEach((model) => {
                                    productT.forEach((trim) => {
                                        productYMM.push({
                                            "year": year,
                                            "model": model,
                                            "trim": trim,
                                        });
                                    });
                                });
                            });
                        }
                        if(productYMM.length > 0) {
                            this.products[productId] = productYMM;
                        }
                        if(this.products && this.products.hasOwnProperty(productId)) {
                            let models = this.products[productId];
                            models.forEach(model => {
                                if(model.year === this.activeCar['year'] && model.model === this.activeCar['model'] && model.trim === this.activeCar['trim']) {
                                    fits = 'yes';
                                }
                            })
                            if(fits === '') {
                                fits = 'no';
                            }
                        }
                        if(fits === '') {
                            fits = 'maybe';
                        }
                        productCard.dataset.productFits = fits;
                        productCard.querySelectorAll('[data-product-thumbnail-model]').forEach((slot) => {
                            slot.innerText = this.activeCarLabel;
                        })
                        if(!skipSort && (!sortBy || sortBy === '')) {
                            sorted[fits].push(productCard);
                        }
                        productCard.querySelector('.product-thumbnail-fit-wrapper a').style.display = 'none';
                    });
                    if(!skipSort && (!sortBy || sortBy === '')) {
                        let index = 0;
                        for(const fit in sorted) {
                            if(sorted[fit].length > 0) {
                                sorted[fit].forEach((card) => {
                                    card.style.order = index;
                                    index++;
                                });
                            }
                        }
                    }

                } else {
                    productCards.forEach((productCard) => {
                        productCard.dataset.productFits = '';
                        productCard.querySelectorAll('[data-product-thumbnail-model]').forEach((slot) => {
                            slot.innerText = '';
                        });
                        productCard.style.removeProperty('order');
                        productCard.querySelector('.product-thumbnail-fit-wrapper a').style.display = 'block';
                    });
                }

            }
        },
        _initModelData(sectionData) {
            const rows = sectionData.hasOwnProperty('data') ? sectionData.data : null;
            let processed = {};
            if(rows) {
                rows.forEach(row => {
                    const dataArray = row.split('|');
                    const productIds = dataArray[0].split('~');
                    productIds.forEach((productId) => {
                        if(productId) {
                            if(!processed.hasOwnProperty(productId)) {
                                processed[productId] = [];
                            }
                            processed[productId].push({
                                'year': dataArray[1],
                                'model': dataArray[2],
                                'trim': dataArray[3],
                            });
                            if(!this.ymmMatrix.hasOwnProperty(dataArray[1])) {
                                this.ymmMatrix[dataArray[1]] = {};
                            }
                            if(!this.ymmMatrix[dataArray[1]].hasOwnProperty(dataArray[2])) {
                                this.ymmMatrix[dataArray[1]][dataArray[2]] = [];
                            }
                            if(this.ymmMatrix[dataArray[1]][dataArray[2]].indexOf(dataArray[3]) === -1) {
                                this.ymmMatrix[dataArray[1]][dataArray[2]].push(dataArray[3]);
                            }
                            if(this.years.indexOf(dataArray[1]) === -1) {
                                this.years.push(dataArray[1]);
                            }
                            if(this.models.indexOf(dataArray[2]) === -1) {
                                this.models.push(dataArray[2]);
                            }
                            if(this.trims.indexOf(dataArray[3]) === -1) {
                                this.trims.push(dataArray[3]);
                            }
                        }
                    })
                })
            }
            this.products = processed;
            this.years.sort();
            this.models.sort();
            this.trims.sort();
            for(const year in this.ymmMatrix) {
                for(const model in this.ymmMatrix[year]) {
                    this.ymmMatrix[year][model].sort();
                }
            }
            if(sectionData.hasOwnProperty('product')) {
                this.product = sectionData.product;
                if(this.product) {
                    let productYMM = [];
                    let productY = [];
                    let productM = [];
                    let productT = [];
                    if(sectionData.hasOwnProperty('year')) {
                        productY = sectionData['year'].split('|');
                    }
                    if(sectionData.hasOwnProperty('model')) {
                        productM = sectionData['model'].split('|');
                    }
                    if(sectionData.hasOwnProperty('trim')) {
                        productT = sectionData['trim'].split('|');
                    }
                    if(productY.length > 0 && productM.length > 0 && productT.length > 0) {
                        productY.forEach((year) => {
                            productM.forEach((model) => {
                                productT.forEach((trim) => {
                                    productYMM.push({
                                        "year": year,
                                        "model": model,
                                        "trim": trim,
                                    });
                                });
                            });
                        });
                    }
                    if(productYMM.length > 0) {
                        this.products[this.product] = productYMM;
                    }

                }
            }
        },
        _initCustomerToken() {
            if(localStorage.getItem("customer_api_token")) {
                const query = () => `
                mutation customerAccessTokenRenew($customerAccessToken: String!) {
                    customerAccessTokenRenew(customerAccessToken: $customerAccessToken) {
                        customerAccessToken {
                            accessToken
                            expiresAt
                        }
                    }
                }`
                const input = () => {
                    return {
                        "customerAccessToken": localStorage.getItem("customer_api_token")
                    }
                }
                fetch(this.api_url, {
                    method: 'POST',
                    headers: this.api_headers,
                    body: JSON.stringify({query: query(), variables: input()})
                }).then((response) => response.json())
                    .then((customer) => {
                        if(customer.data.customerAccessTokenRenew.customerAccessToken) {
                            localStorage.setItem("customer_api_token", customer.data.customerAccessTokenRenew.customerAccessToken.accessToken);
                            localStorage.setItem("customer_api_token_expire", Date.parse(customer.data.customerAccessTokenRenew.customerAccessToken.expiresAt));
                            localStorage.removeItem("temp_customer_pass");
                        }

                        this._checkCustomerCars();
                    }).catch((e) => {
                    console.error(e);
                    localStorage.removeItem("customer_api_token");
                    localStorage.removeItem("customer_api_token_expire");
                    localStorage.removeItem("customer_api_id");
                })
            } else {
                if((typeof window.customer_info != 'undefined') && window.customer_info !== '' && window.customer_info !== null && localStorage.getItem("temp_customer_pass")) {
                    const query = () => `
                    mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
                        customerAccessTokenCreate(input: $input) {
                        customerAccessToken {
                            accessToken
                            expiresAt
                        }
                        }
                    }`
                    const input = () => {
                        return {
                            "input": {
                                "email": window.customer_info.email,
                                "password": localStorage.getItem("temp_customer_pass")
                            }
                        }
                    }
                    fetch(this.api_url, {
                        method: 'POST',
                        headers: this.api_headers,
                        body: JSON.stringify({query: query(), variables: input()})
                    }).then((response) => response.json())
                        .then((customer) => {
                            localStorage.setItem("customer_api_token", customer.data.customerAccessTokenCreate.customerAccessToken.accessToken);
                            localStorage.setItem("customer_api_token_expire", Date.parse(customer.data.customerAccessTokenCreate.customerAccessToken.expiresAt));
                            localStorage.removeItem("temp_customer_pass");
                            this._checkCustomerCars();
                        }).catch((e) => {
                        console.error(e);
                        localStorage.removeItem("customer_api_token");
                        localStorage.removeItem("customer_api_token_expire");
                        localStorage.removeItem("customer_api_id");
                    })
                }
            }
        },
        _checkCustomerCars() {
            const query = () => `
            {
                customer(customerAccessToken: "${localStorage.getItem("customer_api_token")}") {
                    id
                    my_cars: metafield(namespace: "tesla", key: "my_cars") {
                        id
                        value
                    }
                }
            }`
            const input = () => {
                return {}
            }
            fetch(this.api_url, {
                method: 'POST',
                headers: this.api_headers,
                body: JSON.stringify({query: query(), variables: input()})
            }).then((response) => response.json())
                .then((customer) => {
                    let updateMetafields = false;
                    localStorage.setItem("customer_api_id", customer.data.customer.id);
                    if(customer.data.customer.my_cars && customer.data.customer.my_cars.value) {
                        localStorage.setItem("api_my_cars_id", customer.data.customer.my_cars.id);
                        localStorage.setItem("api_my_cars_value", customer.data.customer.my_cars.value);
                    } else if(this.myCars.length > 0)
                        updateMetafields = true;

                    if (updateMetafields)
                        this._updateCustomerMetafields();
                    else
                        this._updateCustomerTesla();
                }).catch((e) => {
                console.error(e)
            });
        },
        _updateCustomerMetafields() {
            if(localStorage.getItem("customer_api_id") && this.myCars.length > 0) {
                let metafields = [];
                if(localStorage.getItem("api_my_cars_id")) {
                    metafields.push({
                        id: localStorage.getItem("api_my_cars_id"),
                        value: JSON.stringify(this.myCars)
                    })
                } else {
                    metafields.push({
                        namespace: 'tesla',
                        key: 'my_cars',
                        value: JSON.stringify(this.myCars),
                        type: "json"
                    })
                }
                const input = () => {
                    return {
                        input: {
                            metafields: metafields,
                            id: localStorage.getItem('customer_api_id')
                        }
                    }
                }

                console.log(input());

                fetch('https://shopify-cache.obsessive.dev/tesbros/update_customer_metafields.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify(input())
                }).then((response) => response.json())
                    .then((customer) => {
                        console.log(customer);
                        if(customer.data && customer.data.customerUpdate && customer.data.customerUpdate.customer && customer.data.customerUpdate.customer.metafields.edges) {
                            const metafields = customer.data.customerUpdate.customer.metafields.edges;
                            for (let index = 0; index < metafields.length; index++) {
                                const element = metafields[index].node;
                                if (element.namespace === 'tesla' && element.key === 'my_cars') {
                                    localStorage.setItem("api_my_cars_id", element.id);
                                    const parsed = JSON.stringify(element.value);
                                    localStorage.setItem("api_my_cars_value", parsed);
                                }
                            }
                            this._updateCustomerTesla();
                        }
                    }).catch((e) => {
                    console.error(e)
                });
            }
        },
        _updateCustomerTesla() {
            const data = JSON.parse(localStorage.getItem('api_my_cars_value')) || [];
            store.dispatch('garage/load', {
                cars: data
            })
        },
        carLabel(car) {
            if(car.hasOwnProperty('year')) {
                return (car.name && car.name !== '') ? car.name : car.year + ' ' + car.model;
            }
        },
        _validateSelection() {
            let valid = true;
            for(const name in this.dropdowns) {
                if(name !== 'name' && this.dropdowns[name] === '') {
                    this.errors[name] = true;
                    valid = false;
                }
            }
            return valid;
        },
        openPopup() {
            this.open = true;
            document.body.classList.add('limitless-popup-open');
        },
        openSpecialPopup() {
            this.open = false;
            this.specialOpen = true;
            document.body.classList.add('limitless-popup-open');
        },
        closePopup() {
            this.open = false;
            document.body.classList.remove('limitless-popup-open');
        },
        closeSpecialPopup() {
            this.specialOpen = false;
            document.body.classList.remove('limitless-popup-open');
        },
        addNewCar() {
            this.addNew = true;
        },
        saveNewCar() {
            if(!this._validateSelection()) {
                return false;
            }
            this._resetErrors();
            const newCar = {'year': this.dropdowns['year'], 'model': this.dropdowns['model'], 'trim': this.dropdowns['trim'], 'name': this.dropdowns['name'], 'active': true};
            store.dispatch('garage/add', {
                car: newCar
            })
            this._updateCollection(true);
            if(this.product) {
                this._updateProductBlocks();
            }
            this.dropdowns = this.cloneObject(this.template);
            this.addNew = false;
            this.closePopup();
        },
        updateActiveCar() {
            const i = document.querySelector('input[name="my_cars[]"]:checked').value;
            store.dispatch('garage/change', {
                index: i
            })
            this._updateCollection(true);
            if(this.product) {
                this._updateProductBlocks();
            }
            this.closePopup();
        },
        editCar(index) {
            if(typeof this.myCars[index] !== "undefined") {
                for(const name in this.dropdowns) {
                    if(this.myCars[index].hasOwnProperty(name)) {
                        setTimeout(() => {
                            this.dropdowns[name] = this.myCars[index][name];
                        },250);
                    }
                }
                this.edit = index;
            }
        },
        saveCar() {
            if(!this._validateSelection()) {
                return false;
            }
            this._resetErrors();
            const newCar = {'year': this.dropdowns['year'], 'model': this.dropdowns['model'], 'trim': this.dropdowns['trim'], 'name': this.dropdowns['name'], 'active': true};
            store.dispatch('garage/update', {
                index: this.edit,
                car: newCar
            })
            this._updateCollection(true);
            if(this.product) {
                this._updateProductBlocks();
            }
            this.edit = null;
            this.dropdowns = this.cloneObject(this.template);
        },
        removeCar() {
            if(this.edit !== null) {
                store.dispatch('garage/remove', {
                    index: this.edit
                })
                this._updateCollection(true);
                if(this.product) {
                    this._updateProductBlocks();
                }
                this.edit = null;
                this.dropdowns = this.cloneObject(this.template);
            }
        },
        _resetErrors() {
            this.errors = {'year':false,'model':false,'trim':false};
        }
    },
    template: `
        <div v-if="special !== false" class="limitless-overlay" :class="{'open':specialOpen}" @click="closeSpecialPopup()">
          <div class="limitless-popup limitless-special-popup" :class="{'open':specialOpen}">
            <div class="limitless-popup-wrapper" @click.stop="">
              <div class="contents">
                <div class="title"><span data-popup-title>Fit Guide</span></div>
                <div class="content" v-html="special"></div>
                <div class="popup-actions">
                  <button type="button" class="button" @click="closeSpecialPopup()">Close</button>
                </div>              
              </div>
              <button type="button" class="close" @click="closeSpecialPopup()"><span class="sr-only">Close</span></button>
            </div>
          </div>
        </div>
        <div class="limitless-overlay" :class="{'open':open}" @click="closePopup()">
          <div class="limitless-popup limitless-add-popup" :class="{'open':open}">
            <div class="limitless-popup-wrapper" @click.stop="">
              <div class="contents" v-if="activeCar && !addNew && edit === null">
                <div class="title"><span class="ymm-tesla-icon tesla-icon-blue"></span><span data-popup-title>Change your Vehicle(s)</span></div>
                <p>Currently shopping for</p>
                <ul class="car-list">
                  <li v-for="(car, index) in myCars" :key="index">
                    <input type="radio" name="my_cars[]" :value="index" :id="'car-index-'+index" class="sr-only" :checked="car.active">
                    <div class="car-list-item" :class="{'active':car.active}">
                      <label :for="'car-index-'+index" v-text="carLabel(car)"></label>
                      <a href="#" @click.prevent="editCar(index)">Edit Details</a>
                    </div>
                  </li>
                </ul>
                <div class="popup-actions"><a href="#" @click.prevent="addNewCar()">+ Add Another Tesla</a></div>
                <div class="popup-actions">
                  <button type="button" class="button" @click="updateActiveCar()">Save &amp; Close</button>
                </div>              
              </div>
              <div class="contents" v-if="!activeCar || addNew || edit !== null">
                <div class="title"><span class="ymm-tesla-icon tesla-icon-blue"></span><span>{{ addNew ? 'Add your Tesla':'Change your Vehicle(s)'}}</span></div>
                <a href="#" v-if="addNew || edit !== null" @click.prevent="addNew = false;edit = null;_resetErrors()" class="back-link">Back</a>
                <p v-if="addNew">Add a Tesla</p>
                <p v-if="edit !== null">Edit Your Tesla</p>
                <ul class="add-form">
                  <li>
                    <label for="ymm-year-v2">Year</label>
                    <select id="ymm-year-v2" name="ymm-year" v-model="dropdowns['year']" :class="{'error':errors['year'] === true}">
                      <option disabled value="">Choose Year</option>
                      <option v-for="year in years" :value="year">{{year}}</option>
                    </select>
                    <p class="error" v-if="errors['year'] === true">Please select Year</p>
                  </li>
                  <li>
                    <label for="ymm-model-v2">Model</label>
                    <select id="ymm-model-v2" name="ymm-model" disabled v-if="!yearModels || yearModels.length === 0">
                      <option>Choose Model</option>
                    </select>
                    <select v-else id="ymm-model-v2" name="ymm-model" v-model="dropdowns['model']" :class="{'error':errors['model'] === true}">
                      <option disabled value="">Choose Model</option>
                      <option v-for="model in yearModels" :value="model">{{model}}</option>
                    </select>
                    <p class="error" v-if="errors['model'] === true">Please select Model</p>
                  </li>
                  <li>
                    <label for="ymm-trim-v2">Trim</label>
                    <select id="ymm-trim-v2" name="ymm-trim" disabled v-if="!modelTrims || modelTrims.length === 0">
                      <option>Choose Trim</option>
                    </select>
                    <select v-else id="ymm-trim-v2" name="ymm-trim" v-model="dropdowns['trim']" :class="{'error':errors['trim'] === true}">
                      <option disabled value="">Choose Trim</option>
                      <option v-for="trim in modelTrims" :value="trim">{{trim}}</option>
                    </select>
                    <p class="error" v-if="errors['trim'] === true">Please select Trim</p>
                  </li>
                  <li>
                    <label for="ymm-name-v2">Car Name (optional)</label>
                    <input type="text" id="ymm-name-v2" name="ymm-name-v2" placeholder="Ex: Elsa" v-model.trim="dropdowns['name']">
                  </li>
                </ul>
                <div class="popup-actions" v-if="addNew"><a href="#" @click.prevent="addNew = false;_resetErrors()">Cancel &amp; Remove</a></div>
                <div class="popup-actions" v-if="edit !== null"><a href="#" @click.prevent="removeCar()">Remove Vehicle</a></div>
                <div class="popup-actions">
                  <button v-if="edit !== null" type="button" class="button" @click="saveCar()">Save Changes</button>
                  <button v-else type="button" class="button" @click="saveNewCar()">Add My Vehicle</button>
                </div>
              </div>
              <button type="button" class="close" @click="closePopup()"><span class="sr-only">Close</span></button>
            </div>
          </div>
        </div>
        <teleport to="#megaYmm" v-if="isMounted">
          <label for="mega-ymm-v2" v-if="activeCar"><a href="#" role="button" class="navbar-link header__link" @click.prevent="openPopup()"><span class="ymm-tesla-icon tesla-icon-blue"></span><span v-html="activeCarLabel"></span></a></label>
          <label for="mega-ymm-v2" v-else><a href="#" role="button" class="navbar-link header__link" @click.prevent="openPopup()"><span class="ymm-tesla-icon tesla-icon-blue"></span><span>Add your Tesla</span></a></label>
        </teleport>
        <teleport to="#mobileMegaYmm" v-if="isMounted">
          <template v-if="activeCar"><a href="#" @click.prevent="openPopup()"><span class="ymm-tesla-icon tesla-icon-blue"></span><span data-popup-title v-html="activeCarLabel"></span></a></template>
          <template v-else><a href="#" @click.prevent="openPopup()"><span class="ymm-tesla-icon tesla-icon-blue"></span><span data-popup-title>Add your Tesla</span></a></template>
        </teleport>
        <teleport to="#ymmProductApp" v-if="isMounted && product">
            <div class="ymm-product-blocks">
              <div class="ymm-product-block ymm-add" v-if="myCars.length === 0">
                <div class="ymm-title">
                  <span class="ymm-tesla-icon tesla-icon-gray"></span> <span class="ymm-title-text">Check if this fits your Vehicle</span>
                </div>
                <button type="button" class="button" @click.prevent="openPopup()">Add Tesla</button>
              </div>
              <div class="ymm-product-block ymm-fit" v-if="myCars.length > 0 && fits && special === false">
                <div class="ymm-title">
                  <span class="ymm-tesla-icon tesla-icon-blue"></span> <span class="ymm-title-text" v-html="activeCarLabel"></span> <a href="#" @click.prevent="openPopup()">Change</a>
                </div>
                <div class="ymm-message message-fit">
                  <span class="ymm-tesla-icon ymm-tesla-icon-small tesla-icon-checkmark"></span> <span>Aw yeah! This fits your Tesla.</span>
                </div>
              </div>
              <div class="ymm-product-block ymm-nofit" v-if="myCars.length > 0 && !fits && special === false">
                <div class="ymm-title">
                  <span class="ymm-tesla-icon tesla-icon-blue"></span> <span class="ymm-title-text" v-html="activeCarLabel"></span> <a href="#" @click.prevent="openPopup()">Change</a>
                </div>
                <div class="ymm-message message-nofit">
                  <span class="ymm-tesla-icon ymm-tesla-icon-small tesla-icon-no"></span> <span>Aw man! This does not fit your Tesla.</span>
                </div>
              </div>
              <div class="ymm-product-block ymm-special" v-if="myCars.length > 0 && special !== false">
                <div class="ymm-title">
                  <span class="ymm-tesla-icon ymm-tesla-icon-small tesla-icon-attention"></span> <span class="ymm-title-text">Special Fit Notice</span>
                </div>
                <p>This product takes some extra explaining to see if it'll fit your Tesla. Check out our guide to know for sure.</p>
                <a href="#" @click.prevent="openSpecialPopup()">See Fit Guide</a>
              </div>
            </div>
        </teleport>
    `
}, { ...rootEl.dataset })
ymmApp.use(tesbrosPlugin).use(store);
ymmApp.config.unwrapInjectedRef = true
ymmApp.mount('#ymmApp');

